import { LuxuryHomesPlace } from '@components';

import React from 'react';

const LuxuryHomesPlacePage: React.FC = () => {
  return (
    <LuxuryHomesPlace />
  );
};

export default LuxuryHomesPlacePage; 